<template>
  <div style="background-color:#fff;height: 100%;">
    <van-sticky :offset-top="0 " >
      <mini_head_top> </mini_head_top>
    </van-sticky>
    <van-row  type="flex"  justify="space-between" style="margin-left :10px; padding: auto; margin-top:10px;text-align: left">
      <van-col :span= '20'>
        <span style="margin-left: 0px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
        <span style="font-size:16px; font-weight:700">错题集</span>
      </van-col>
      <van-col >
        <el-link :span= '4' style="margin-right: 10px;" type="primary" @click.native="goHome()">主页 <i class= "el-icon-s-home"> </i></el-link>
      </van-col>        
    </van-row >
    <div class = "w-e-text-container"  style="height:calc( 100vh - 150px ); overflow: auto;">
      <div  v-if ="qbView.errorId != '' && qbView.errorId != 0" style="text-align:left ; margin:10px; overflow:auto;">
        <div slot="header" class="clearfix">
          <el-tag size="mini" type="warning">{{ qbView.uniqNo }}</el-tag>
          <el-tag  size="mini" style ="margin-left: 10px;">{{ qbView.moduleName }}</el-tag>
          <el-tag size="mini" type="success">{{  qbView.answerCheckType }}</el-tag>
          <el-button  type="danger" style="el-icon--right" @click="removeErrorQb()" size = "small" icon="">移出错题集 <i class="el-icon-arrow-right el-icon--right"></i></el-button>
        </div>
        <div style ="margin-top: 10px;" >
          <el-tag size="mini" type="warning">问题</el-tag>
          <span style ="margin-left: 10px;">{{qbView.question }}</span>
        </div>
        <div style ="margin-top: 10px;" v-if = "qbView.imageUrlList.length > 0 "> 
          <el-tag size="mini" type="warning" style="padding-top: 0px">图片</el-tag>
          <el-badge  v-for="(item,index) in qbView.imageUrlList" :key = "index"  :value="index + 1" class="item">
            <el-image   
              style="width: 100px; height: 100px;margin-left: 10px;"
              :src="item.url"
              :fit="fit">
            </el-image>
          </el-badge>
        </div>
        <div style ="margin-top: 10px;">
          <el-row>
            <el-col :span="2">
              <el-tag size="mini" type="warning">选项</el-tag>
            </el-col>
            <el-col :span="22">
              <el-checkbox-group v-model="qbView.checkedOptList" >
                <el-checkbox style ="margin-left: 10px;word-break: break-all;display: block;overflow:
                hidden; text-overflow: ellipsis;white-space: normal"
                :disabled = "true" v-for="(opt , index ) in qbView.optionValueArr" 
                :label="String.fromCharCode(65 + index)" :key="opt">
                    {{opt}}
                </el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>
        </div>
        <div style ="margin-top: 10px;"  >
          <el-tag  size="mini" type="warning">我的答案</el-tag>
          <span style ="margin-left: 10px;">{{qbView.learnAnswer }}</span>
          <el-button  size="mini"  :type="qbView.resultOk ? 'success':'danger'"
            :icon="qbView.resultOk ? 'el-icon-check': 'el-icon-close'" circle></el-button>
        </div>
        <div style ="margin-top: 10px;">
          <el-tag size="mini" type="warning">操作</el-tag>
         
          <el-button  type="primary"  style="padding:2px; margin-left: 10px;"  size = "small" icon="el-icon-arrow-left"  @click = "learnNextQb2(false)" >上一题</el-button>
          <el-button  type="primary" style="padding:1px;"  size = "small"  @click = "learnNextQb2(true)" icon="">下一题 <i class="el-icon-arrow-right el-icon--right"></i></el-button>
        </div >
        <div style ="margin-top: 10px;" >
          <el-tag size="mini" type="warning">答案</el-tag>
          <span style ="margin-left: 10px;" > {{qbView.answer }}</span>
        </div >
        <div style ="margin-top: 10px;" >
          <el-tag  type="warning"  >解析</el-tag>
          <span style ="margin-left: 10px;"> {{qbView.analysis }}</span>
        </div>
      </div>
    </div>
  </div>
</template>                     
<script>
// 引入组
import '@wangeditor/editor/dist/css/style.css'

import axios from  '@/api/axiosConfig'
import mini_head_top from "@/mini_pages/mini_head_top"
import {MESSAGE_DURATION} from  '@/api/constant'
export default {
  name : 'mini_error',
  data() {
    return {
      qbView : {
        errorId :'',
        checkedOptList:[],
        analysis:'',
        answer:'',
        question :'',
        optionValueArr:[],
        moduleName:'',
        uniqNo:'',
        id: '',
        learnAnswer :'',
        learnTime :'',
        answerCheckType :'',
        selected : false,
        resultOk: false,
        seeAnswer:false,
        imageUrlList :[]
      },
      
      tokenObj:{

        token :''
      }
    }
  },
  methods : {
    goHome(){
      this.$router.push({path:'/mini_index'})
    },
    removeErrorQb(){
      if(this.qbView.errorId == ''){
          return
      }
      let url = "/bc/exa/error/deleteError"
      let dat0 = { id :this.qbView.errorId }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            showClose: true,
            message: '移除错题成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          setTimeout(()=>{this.errorNextOneLoad(this.qbView.errorId,true)},200)
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      })
    },

    learnNextQb2(asc){

      this.errorNextOneLoad(this.qbView.errorId ,asc) 

    },

 
    errorNextOneLoad(errorId,asc){
      let url = "/bc/exa/error/nextQb"
      let dat0 = { errorId, asc }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          this.qbView.errorId = dat.errorId
          this.qbView.analysis = dat.analysis
          this.qbView.id = dat.id
          this.qbView.answer = dat.answer
          this.qbView.question = dat.question 
          this.qbView.moduleName = dat.moduleName
          this.qbView.uniqNo = dat.uniqNo
          this.qbView.answerCheckType =dat.answerCheckType
          this.qbView.learnAnswer = dat.errorAnswer
          this.qbView.resultOk =  dat.resultOk
         //this.qbErrorView.learnTime = dat.learnTime
          this.qbView.imageUrlList.splice(0)
          this.qbView.optionValueArr.splice(0)
          // this.qbErrorView.checkedOptList.splice(0)
          for(let i = 0; i< 5; i++){
            let v =  dat['option' + (i + 1)]
            if(v != null &&  v != '') {
              let ch = String.fromCharCode(i + 1 + 64)
              this.qbView.optionValueArr.push(ch + "."+ v + ";")
            }
          }
          for(let i = 0; i< dat.countImage; i++){
            this.qbView.imageUrlList.push({name: dat.id , url : dat['fileUrl'+ (i+1)]})
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      })
    },
    // clearViewQbOneDetail(){
    //    this.viewQbOneDetail.learnOkPer = ''
    //    this.viewQbOneDetail.learnPer = ''
    //    this.viewQbOneDetail.moduleId = ''
    //    this.viewQbOneDetail. moduleName = ''
    //    this.viewQbOneDetail.totalCount  = ''
    //    this.viewQbOneDetail.learnCount  = ''
    //    this.viewQbOneDetail.learnOkCount  = ''
    //    this.viewQbOneDetail.qtList.splice(0)
    //    clearViewQbForm()
    // },




  },
  created () {
   
    setTimeout(()=>{this.errorNextOneLoad(0,true)},200)
  },
  mounted() {
     
  },
  components:{
      mini_head_top
    }
}
</script>

<style lang="less" scoped>
.el-card {
  height: 99%

}
/deep/.el-card__body {
  padding-top:0px;
}
.text {
  font-size: 14px;
  color: #000;
}

.notice-content-view {
  border: 3px solid #ccc;
  border-radius: 5px;
  padding: 0 10px;
  margin-top: 20px;
  overflow-x: auto;
}

.notice-content-view p,
.notice-content-view li {
  white-space: pre-wrap; /* 保留空格 */
}

.notice-content-view blockquote {
  border-left: 8px solid #d0e5f2;
  padding: 10px 10px;
  margin: 10px 0;
  background-color: #f1f1f1;
}

.notice-content-view code {
  font-family: monospace;
  background-color: #eee;
  padding: 3px;
  border-radius: 3px;
}
.notice-content-view pre>code {
  display: block;
  padding: 10px;
}

.notice-content-view table {
  border-collapse: collapse;
}
.notice-content-view td,
.notice-content-view th {
  border: 1px solid #ccc;
  min-width: 50px;
  height: 20px;
}
.notice-content-view th {
  background-color: #f1f1f1;
}

.notice-content-view ul,
.notice-content-view ol {
  padding-left: 20px;
}

.notice-content-view input[type="checkbox"] {
  margin-right: 5px;
}
</style>
    


// WEBPACK FOOTER //
// src/mini_pages/mini_error.vue